import { Injectable } from '@angular/core';

import { DocumentTemplateRole } from '../../models/document-template-role';
import { DocumentTemplateRoleName } from '../../models/document-template-role-name';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class DocumentTemplateRoleNameService extends BackendBaseService {
  url = 'document_template_role_names';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  save(documentTemplateRoleName: DocumentTemplateRoleName): Promise<any> {
    return super.save({
      id: documentTemplateRoleName.id,
      document_template_role_name: documentTemplateRoleName
    });
  }

  saveDocumentTemplateRole(documentTemplateRole: DocumentTemplateRole): Promise<any> {
    return this.httpClient.put(`${this.url}/${documentTemplateRole.document_template_role_name_id}.json`, { document_template_role: documentTemplateRole, save_document_template_role: true });
  }

  removeDocumentTemplateRole(documentTemplateRole: DocumentTemplateRole): Promise<any> {
    return this.httpClient.put(`${this.url}/${documentTemplateRole.document_template_role_name_id}.json`, { document_template_role_id: documentTemplateRole.id, remove_document_template_role: true });
  }

  templates(document_template_role_name_id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${document_template_role_name_id}.json`, { templates: true });
  }
}
